export default (apiInstance, oauthInstance, libraryServicesApi) => {
    const library = {}

    library.loginWithCognito = (token) => {
        return apiInstance.post('/auth/cognito-login-ad', { token })
    }

    library.currentUser = (accessToken) => {
        apiInstance.defaults.headers.common['Authorization'] = libraryServicesApi.addTokenPrefix(accessToken)
        return apiInstance.get('/users/current')
    }

    library.logout = () => {
        return apiInstance.post('/auth/logout')
    }

    library.refreshAccessToken = (username, clientId, clientSecret, refreshToken) => {
        return oauthInstance.post('/oauth/token', {
            username,
            client_id: clientId,
            client_secret: clientSecret,
            refresh_token: refreshToken,
            grant_type: 'refresh_token',
        })
    }

    library.login =
        (clientId, clientSecret) =>
        (username, password, cpf = false) => {
            return oauthInstance.post('/auth/login', {
                grant_type: 'password',
                client_id: clientId,
                client_secret: clientSecret,
                username,
                password,
                cpf,
            })
        }

    library.forgotPassword = (username, captcha, locale, cpf = false) => {
        return apiInstance.post('/password-reset/create', {
            email: username,
            captchaToken: captcha,
            locale,
            cpf,
        })
    }

    library.resetPasswordFind = (token) => {
        return apiInstance.get('/password-reset/find/' + token)
    }

    library.resetPassword = (token, email, password) => {
        return apiInstance.post('/password-reset/reset', {
            token,
            email,
            password: {
                new_password: password,
                new_password_confirm: password,
            },
        })
    }

    return library
}
